import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ArrowLeft, Edit3, Globe, Shield, FileText, AlertTriangle, HelpCircle, Flag, TrendingUp, ChevronRight, LogOut, Bell, Trophy, Target, Compass, Gift, Crown, Zap, ShieldOff } from "lucide-react";

const ITEMS = [
  { to: "/profile/edit", icon: Edit3, label: "Edit Profile", desc: "Name, bio, avatar, social links" },
  { to: "/monetization", icon: TrendingUp, label: "Monetization Criteria", desc: "Track 5 reels @ 1L views to go viral" },
  { to: "/leaderboard", icon: Trophy, label: "Leaderboard", desc: "Top streamers, gifters, battles" },
  { to: "/missions", icon: Target, label: "Mission Hifireels", desc: "Tasks & rewards" },
  { to: "/notifications", icon: Bell, label: "Notifications", desc: "All your alerts" },
  { to: "/settings/blocked", icon: ShieldOff, label: "Blocked Accounts", desc: "See and unblock people you've blocked" },
  { to: "/help", icon: HelpCircle, label: "Help & Support", desc: "FAQ + Contact us" },
  { to: "/privacy", icon: Shield, label: "Privacy Policy", desc: "How we handle your data" },
  { to: "/terms", icon: FileText, label: "Terms & Conditions", desc: "User agreement" },
  { to: "/violation", icon: AlertTriangle, label: "Violation Policy", desc: "Community guidelines" },
];

export default function Settings() {
  const { logout, user } = useAuth();
  return (
    <div className="px-4 py-6">
      <div className="flex items-center gap-3 mb-1">
        <Link to="/profile"><ArrowLeft className="w-5 h-5"/></Link>
        <h1 className="font-outfit font-extrabold text-2xl tracking-tighter">Settings</h1>
      </div>
      <p className="text-white/60 text-xs mb-5 ml-8">Manage your account & legal</p>

      <div className="space-y-2 mb-6" data-testid="settings-list">
        {ITEMS.map(i => (
          <Link key={i.to} to={i.to} data-testid={`set-${i.label.toLowerCase().replace(/\s+/g,"-")}`}
            className="flex items-center gap-3 p-3 rounded-2xl bg-white/5 border border-white/10 active:scale-[0.99]">
            <div className="w-10 h-10 rounded-xl bg-white/5 flex items-center justify-center">
              <i.icon className="w-4 h-4 text-[#00E5FF]"/>
            </div>
            <div className="flex-1">
              <div className="font-semibold text-sm">{i.label}</div>
              <div className="text-[10px] text-white/60">{i.desc}</div>
            </div>
            <ChevronRight className="w-4 h-4 text-white/30"/>
          </Link>
        ))}
      </div>

      <button onClick={logout} data-testid="settings-logout" className="w-full p-3 rounded-2xl bg-[#FF2A5F]/10 border border-[#FF2A5F]/30 text-[#FF2A5F] font-bold flex items-center justify-center gap-2">
        <LogOut className="w-4 h-4"/>Logout
      </button>

      <p className="text-center text-[10px] text-white/40 mt-6">Hifireels v1.6.0 • {user?.email}</p>
    </div>
  );
}
